<template>
  <v-col
    cols="12"
    sm="5"
    v-if="!checkNil(bestleistung) && !checkNil(bestleistung.ergebnis) && bestleistung.ergebnis > 0"
  >
    <v-card class="mx-auto">
      <v-card-title
        primary-title
        class="grey lighten-1 py-0"
      >
        <v-row class="text-center">
          <v-col cols="12" class="pb-0">
            <template v-if="isHeim">
              Heimbestleistung
            </template>
            <template v-else>
              Auswärtsbestleistung
            </template>
          </v-col>
          <v-col cols="12" class="headline font-weight-black">
            Mannschaft
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider class="grey darken-1" />
      <v-card-text
        class="text-center"
      >
        <v-row>
          <v-col cols="12" class="headline font-weight-black primary--text">
            {{ bestleistung.ergebnis }} Kegel
          </v-col>
          <v-col cols="12">
            <v-avatar size="72px">
              <v-img
                :src="showLogo(bestleistung.user.id)"
                alt=""
              />
            </v-avatar>
          </v-col>
          <v-col cols="12" class="title font-weight-black">
            {{ bestleistung.user.teamname }}
          </v-col>

          <v-col cols="12" class="body-2">
            Bahnrekord aufgestellt am {{ bestleistung.saison.spieltag }} Spieltag der
            {{ bestleistung.saison.name }}
            <br>
            Saison Nr: {{ bestleistung.saison.nr }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        Datum: {{ bestleistung.date }}
        <v-spacer />
        <v-btn icon @click="showHeimRekordM = !showHeimRekordM">
          <v-icon>{{ showHeimRekordM ? 'mdi-close' : 'mdi-dots-vertical' }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-slide-y-transition>
        <v-card-text v-show="showHeimRekordM">
          <div class="text-center">
            Spieler des Mannschaftsbahnrekords
          </div>
          <v-simple-table
            class="elevation-4"
          >
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="item in bestleistung.players"
                  :key="item.name"
                >
                  <td class="pa-4">
                    <span class="pl-2 body-2 font-weight-bold">{{ item.name }} ({{ item.heimIndex }} H / {{ item.auswIndex }} A)</span>
                    <br>
                    <v-row
                      justify="center"
                      align="stretch"
                      class="text-center"
                    >
                      <v-col
                        v-for="(icon, index) in dialogHeimIcons"
                        :key="'vitalWertRekordMH'+index"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              :color="item[icon.name] | getStatusColor"
                              v-on="on"
                            >
                              {{ icon.icon }}
                            </v-icon>
                          </template>
                          <span class="text-capitalize">{{ icon.name }}</span>
                        </v-tooltip>
                        <br>
                        {{ item[icon.name] }}
                      </v-col>
                    </v-row>
                  </td>
                  <td class="text-center title font-weight-black">
                    {{ item.ergebnis }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-slide-y-transition>
    </v-card>
  </v-col>
</template>

<script>
const R = require('ramda')
export default {
  name: 'BestleistungMannschaft',
  props: {
    bestleistung: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isHeim: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      showHeimRekordM: false,
      dialogHeimIcons: [
        { name: 'kraft', icon: 'mdi-dumbbell' },
        { name: 'motivation', icon: 'mdi-brain' },
        { name: 'technik', icon: 'mdi-webcam' },
        { name: 'kondition', icon: 'mdi-heart-pulse' }
      ]
    }
  },
  computed: {

  },
  methods: {
    checkNil: function (value) {
      return R.isNil(value)
    },
    showLogo: function (teamId) {
      if (!teamId) return ''
      return this.$store.getters['saisonStore/getLogo'](teamId)
    }
  }
}
</script>
